import { memo, useMemo } from 'react';
import IconButton from '@/components/atoms/Button/IconButton';

interface HeaderProps {
  context: string;
  onClose?: () => void;
}

const Header = memo(({ context, onClose }: HeaderProps) => {
  const getTitle = useMemo(() => {
    switch (context) {
      case 'AI_EDITS':
        return 'AI Edits';
      default:
        return 'AI Assistant';
    }
  }, [context]);

  return (
    <div className="flex w-full items-center justify-between">
      <h2 className="text-lg font-semibold">{getTitle}</h2>
      <IconButton
        icon="IconX"
        onClick={onClose}
        variation="text"
        trackingId="ai-agent-close-button"
        buttonClassName="text-slate-600 hover:bg-slate-100 !p-2 "
        iconClassName="mx-0"
      />
    </div>
  );
});

export default Header;
